var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{attrs:{"max-height":"19","max-width":"19","src":"/img/icons/incomegeneration.svg"}})
}
var staticRenderFns = []

export { render, staticRenderFns }